<template>
  <div id="Page8" class="home">
    <div class="banner">
      <img src="@/assets/img/PG8-1-953x400.png" alt="" />
    </div>
    <div class="bannerBtmLine">
      <div class="leftLine"></div>
      <div class="rightLine"></div>
    </div>
    <div class="mainTop">
      <span class="Breadcrumb">
        <router-link to="/">{{ $t("Homepage") }}</router-link> >
        {{ $t("Lottery") }}</span
      >
      <div class="topLine"></div>
    </div>
    <div class="main">
      <div class="container">
        <div class="card">
          <div class="cardImg">
            <img src="@/assets/img/PG5-1-498x299.png" alt="" />
          </div>
          <div class="cardBody">
            <div class="cardContent">
              <div class="cardTitle">
                {{ $t("PG8C1T") }}
              </div>
              <span>―</span>
              <div class="cardText">
                {{ $t("PG8C1P") }}
              </div>
            </div>
            <div class="cardBtnArea">
              <div class="cardBtnBgImg">
                <img src="@/assets/img/btn.png" alt="" />
              </div>
              <router-link to="/Introduction/5" class="cardBtnText">
                {{ $t("MCBtn") }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="cardImg">
            <img src="@/assets/img/G-2-952x410.png" alt="" />
          </div>
          <div class="cardBody">
            <div class="cardContent">
              <div class="cardTitle">
                {{ $t("PG8C2T") }}
              </div>
              <span>―</span>
              <div class="cardText">
                {{ $t("PG8C2P") }}
              </div>
            </div>
            <div class="cardBtnArea">
              <div class="cardBtnBgImg">
                <img src="@/assets/img/btn.png" alt="" />
              </div>
              <router-link to="/Introduction/6" class="cardBtnText">
                {{ $t("MCBtn") }}
              </router-link>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="cardImg">
            <img src="@/assets/img/G-3-952x410.png" alt="" />
          </div>
          <div class="cardBody">
            <div class="cardContent">
              <div class="cardTitle">
                {{ $t("PG8C3T") }}
              </div>
              <span>―</span>
              <div class="cardText">
                {{ $t("PG8C3P") }}
              </div>
            </div>
            <div class="cardBtnArea">
              <div class="cardBtnBgImg">
                <img src="@/assets/img/btn.png" alt="" />
              </div>
              <router-link to="/Introduction/7" class="cardBtnText">
                {{ $t("MCBtn") }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page8",
};
</script>
<style lang="scss" scoped>
.home {
  width: 100%;
  .banner {
    display: flex;
    justify-content: center;
    video {
      width: 100%;
      &:focus {
        border: none;
        outline: none;
      }
    }
  }

  .main {
    .container {
      .card {
        display: flex;
        box-sizing: border-box;
        padding: 16px;
        border-bottom: 2px solid green;
        .cardImg {
          width: 50%;
        }
        .cardBody {
          width: 50%;
          .cardContent,
          .cardBtnArea {
            height: 50%;
          }
          .cardContent {
            box-sizing: border-box;
            color: #d7af21;
            padding: 16px;
            .cardTitle {
              font-size: 24px;
            }
            .cardText {
              font-style: 20px;
              letter-spacing: 1px;
            }
          }
          .cardBtnArea {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            .cardBtnBgImg {
              width: 200px;
            }
            .cardBtnText {
              color: black;
              font-size: 24px;
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
            }
          }
        }
      }
      .card:nth-child(even) {
        .cardImg {
          order: 1;
        }
      }
    }
  }
}
</style>
